import { type MediaClientCache } from './cache-provider.tsx';
import { createMediaClientCache, type MediaCacheWrapper } from './create-cache-driver.ts';

/**
 * Get or create a cache for a specific contentId.
 */
export function getOrCreateCache(contentId: string, globalCache: MediaClientCache) {
  if (globalCache.has(contentId)) {
    return globalCache.get(contentId) as MediaCacheWrapper;
  }

  const newCache = createMediaClientCache(contentId, globalCache);

  globalCache.set(contentId, newCache);

  return newCache;
}
